var ButtonMessagePage = require("app/AppLayout/ButtonMessagePage"),
    frameThrottle     = require("enyo-perf/utils").frameThrottle,
    icons             = require("app/theme/icons"),
    kind              = require("enyo/kind");

module.exports = kind(/** @lends  app.HomePage.TemporarilyOfflinePageView.prototype */ {

    /**
     * @private
     */
    name: "app.HomePage.TemporarilyOfflinePageView",

    /**
     * @private
     */
    kind: ButtonMessagePage,

    /**
     * @private
     */
    classes: "app-home-page-temporarily-offline-page-view",

    /**
     * @private
     */
    handlers: {
        onMessageButtonTap: "onMessageButtonTap"
    },

    /**
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.$.message.$.button.set("icon", icons["app.HomePage.TemporarilyOfflinePageView.button"]);
        };
    }),

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            $message    = this.$.message;

        $message.$.title.set("content", i18nService.getString("app.HomePage.TemporarilyOfflineError.title"));
        $message.$.body.set("content", i18nService.getString("app.HomePage.TemporarilyOfflineError.body"));
        $message.$.button.set("caption", i18nService.getString("app.HomePage.TemporarilyOfflineError.Button.caption"));
        $message.$.button.set("tooltip", i18nService.getString("app.HomePage.TemporarilyOfflineError.Button.tooltip"));
    },

    /**
     * Just repeat the current request in order to try again.
     *
     * @private
     */
    onMessageButtonTap: function() {
        this.app.$.router.refresh();
    }

});
